var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMapPin = function SvgMapPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 40C80 64 48 88 48 88C48 88 16 64 16 40C16 31.5131 19.3714 23.3737 25.3726 17.3726C31.3737 11.3714 39.5131 8 48 8C56.4869 8 64.6263 11.3714 70.6274 17.3726C76.6286 23.3737 80 31.5131 80 40V40Z",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 52C54.6274 52 60 46.6274 60 40C60 33.3726 54.6274 28 48 28C41.3726 28 36 33.3726 36 40C36 46.6274 41.3726 52 48 52Z",
    stroke: "black",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgMapPin;